import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <footer className='footer'>
            <p>Copyright &#169; 2025 <b>Pulkit Dubey</b>. All rights reserved.<br />
            Developed with ♥ by <b>Pulkit Dubey</b>.</p>
        </footer>
    );
}

export default Footer